module.exports = __webpack_public_path__ + "static/media/occasions-convenience.36f5e270.jpg";